<template>
    <div class="mt-8 lg:mt-0" v-if="tags?.length > 0">
        <hr class="border-t border-gray-300 my-8 lg:hidden" />

        <div id="simillar">
            <h3 class="base_bold">
                {{ $t('similar_posts', { name: $translate(tags[0].name) }) }}
            </h3>

            <Loading class="mt-4" :loading="loading">
                <div>
                    <div v-if="$store.getters['posts/getByKey']('simillar_1')?.data?.length" class="-mx-4 gap-2 flex flex-col">
                        <div v-for="item in $store.getters['posts/getByKey']('simillar_1')?.data" :key="item.id">
                            <TradingRoomPostItem layout="small_image" :key="item.id" :contentstream="item" />
                        </div>
                    </div>
                    <div v-else>
                        {{ $t('no_similar_posts', { name: $translate(tags[0].name) }) }}
                    </div>

                    <router-link
                        :to="'/hkcmnews/?tags=' + $translate(tags[0].name)"
                        class="flex flex-row gap-2 group-hover:gap-3 transition-all ease-in-out duration-500 items-center cursor-pointer mt-6"
                    >
                        <span>
                            {{ $t('all_analysis', { name: $translate(tags[0].name) }) }}
                        </span>
                        <Icon type="ArrowRight" viewBox="0 0 29 21" width="18" height="10" class="fill-none stroke-current transform" />
                    </router-link>
                </div>

                <div class="flex justify-end mt-4">
                    <Pagination :limit="-1" :data="$store.getters['posts/getByKey']('simillar_1')" @pagination-change-page="paginate_1" />
                </div>
            </Loading>
        </div>

        <hr class="border-t border-gray-300 my-8" v-if="tags?.length > 1" />

        <div id="simillar-2" v-if="tags.length > 1">
            <h3 class="base_bold">
                {{ $t('similar_posts', { name: $translate(tags[1].name) }) }}
            </h3>

            <Loading class="mt-4" :loading="loading">
                <div>
                    <div v-if="$store.getters['posts/getByKey']('simillar_2')?.data?.length" class="-mx-4 gap-2 flex flex-col">
                        <div v-for="item in $store.getters['posts/getByKey']('simillar_2')?.data" :key="item.id">
                            <TradingRoomPostItem layout="small_image" :key="item.id" :contentstream="item" />
                        </div>
                    </div>
                    <div v-else>
                        {{ $t('no_similar_posts', { name: $translate(tags[1].name) }) }}
                    </div>

                    <router-link
                        :to="'/hkcmnews/?tags=' + $translate(tags[0].name)"
                        class="flex flex-row gap-2 group-hover:gap-3 transition-all ease-in-out duration-500 items-center cursor-pointer mt-6"
                    >
                        <span>
                            {{ $t('all_analysis', { name: $translate(tags[1].name) }) }}
                        </span>
                        <Icon type="ArrowRight" viewBox="0 0 29 21" width="18" height="10" class="fill-none stroke-current transform" />
                    </router-link>
                </div>

                <div class="flex justify-end mt-4">
                    <Pagination :limit="-1" :data="$store.getters['posts/getByKey']('simillar_2')" @pagination-change-page="paginate_2" />
                </div>
            </Loading>
        </div>

        <hr class="border-t border-gray-300 my-8" />
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['except', 'tags'],
    mounted() {
        this.loading = true;

        let promisses = [];

        if (this.tags?.length > 0) {
            promisses.push(this.indexContentstreams({ key: 'simillar_1', post_tags: [this.tags[0].name], except: [this.except] }));
        }

        if (this.tags?.length > 1) {
            promisses.push(this.indexContentstreams({ key: 'simillar_2', post_tags: [this.tags[1].name], except: [this.except] }));
        }

        Promise.all(promisses).then(() => {
            this.loading = false;
        });
    },

    data: () => ({
        loading: false
    }),

    methods: {
        paginate_1(page) {
            this.indexContentstreams({
                page: page,
                key: 'simillar_1',
                post_tags: [this.tags[0].id]
            });
        },
        paginate_2(page) {
            this.indexContentstreams({
                page: page,
                key: 'simillar_2',
                post_tags: [this.tags[1].id]
            });
        },
        async indexContentstreams(params) {
            let config = {
                params: {
                    popular: true,
                    limit: 3
                }
            };

            _.merge(config.params, params);

            return await this.$store.dispatch('posts/index', config);
        }
    }
};
</script>
